const DESKTOP_MQ = '(min-width: 750px)';

class CoreSlider extends HTMLElement {
  connectedCallback() {
    this._mediaQuery = window.matchMedia(DESKTOP_MQ);
    this._onBreakpointChange = this._onBreakpointChange.bind(this);
    this._mediaQuery.addEventListener('change', this._onBreakpointChange);

    this._init();
  }

  disconnectedCallback() {
    this._mediaQuery?.removeEventListener('change', this._onBreakpointChange);
    this._destroy();
  }

  _shouldLoop() {
    if (this.dataset.enableLoop !== 'true') return false;

    const visibility = this.dataset.loopVisibility || 'both';
    if (visibility === 'both') return true;

    const isDesktop = this._mediaQuery.matches;
    if (visibility === 'mobile-only') return !isDesktop;
    if (visibility === 'desktop-only') return isDesktop;
    return false;
  }

  _buildConfig(enableLoop) {
    const centerSlides = this.dataset.centerSlides === 'true';
    const enableAutoplay = this.dataset.enableAutoplay === 'true';
    const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 3000;
    const enableNavigation = this.dataset.enableNavigation === 'true';
    const enablePagination = this.dataset.enablePagination === 'true';

    const config = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      loop: enableLoop,
      mousewheel: {
        forceToAxis: true,
      },
    };

    if (centerSlides) {
      config.centeredSlides = true;
      // centeredSlidesBounds conflicts with loop mode
      if (!enableLoop) {
        config.centeredSlidesBounds = true;
        config.centerInsufficientSlides = true;
      }
    }

    if (enableAutoplay) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if (enableNavigation) {
      config.navigation = {
        nextEl: this.querySelector('.core-slider__nav--next'),
        prevEl: this.querySelector('.core-slider__nav--prev'),
        disabledClass: 'core-slider__nav--disabled',
      };
    }

    if (enablePagination) {
      config.pagination = {
        el: this.querySelector('.core-slider__pagination'),
        clickable: true,
        bulletClass: 'core-slider__bullet',
        bulletActiveClass: 'core-slider__bullet--active',
      };
    }

    return config;
  }

  _init() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const enableLoop = this._shouldLoop();
    this._loopActive = enableLoop;
    this.swiper = new Swiper(swiperEl, this._buildConfig(enableLoop));
    this.dataset.initialized = 'true';
  }

  _destroy() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
    delete this.dataset.initialized;
  }

  _onBreakpointChange() {
    const enableLoop = this._shouldLoop();
    if (enableLoop === this._loopActive) return;

    const realIndex = this.swiper?.realIndex ?? 0;
    this._destroy();
    this._init();

    if (this.swiper && realIndex > 0) {
      this.swiper.slideTo(realIndex, 0);
    }
  }
}

customElements.define('core-slider', CoreSlider);
